import { RouteConfig } from 'vue-router'
import store from '@/store'

const routes: RouteConfig[] = [
	{
		path: 'recipient',
		component: () => import(/* webpackChunkName: "recipient" */ '@recipient/Index.vue'),
		children: [			
			{
				path: '',
				name: 'recipient-depttree',
				component: () => import(/* webpackChunkName: "recipient" */ '@recipient/components/views/DeptTreeView/DeptTreeView.vue'),				
			}	
		],
	},
]
export default routes
